import { put, call, takeLatest, fork, select } from 'redux-saga/effects'

import RootState from '../root-state'
import { brandsActionType, brandsActions } from './actions'
import { getBrands } from '../api'

export function* fetchBrands() {
  try {
    const state: RootState = yield select()
    const token = state.auth0.auth.idToken
    const response = yield call(getBrands, token)
    yield put(brandsActions.fetchBrandsSucceeded(response.brands))
  } catch (error) {
    yield put(brandsActions.throwError(error))
  }
}

export function* watchFetchBrands() {
  yield takeLatest(brandsActionType.FETCH_BRANDS, fetchBrands)
}

export const brandsSagas = [
  fork(watchFetchBrands),
]
